<template>
    <div >
        首页
    </div>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>